import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Text, HStack, Icon } from "@chakra-ui/react";
import { canShowNavbarAdmissionLink } from "./admissionAccess";
import { motion } from "framer-motion";
import {
  LayoutDashboard,
  User,
  Users,
  ListChecks,
  ExternalLink,
  Package,
  GitBranch,
  MessageCircle,
  FileText,
  Plus,
  Edit,
  Settings,
  HelpCircle,
  Mail,
  Image,
  File,
  MapPin,
  CheckCircle,
  ClipboardList,
  Menu as MenuIcon,
  Inbox,
  UserCheck,
  FileEdit,
  TrendingUp,
  Shield,
  Navigation,
  Scale,
  Phone,
  Bell,
} from "lucide-react";

const Menus = () => {
  const { id } = useParams<string>();
  const location = useLocation();
  const { signinuser } = useSelector((state: any) => state.common);

  const menuIcons: { [key: string]: any } = {
    Dashboard: LayoutDashboard,
    "Profile Settings": User,
    "Raise Ticket": HelpCircle,
    "Add Lead": Plus,
    "Team List": Users,
    "User Details": UserCheck,
    "Admin Details": Shield,
    "Lead List": ListChecks,
    "Source List": ExternalLink,
    "Product List": Package,
    "Branch List": GitBranch,
    "WhatsApp Template": MessageCircle,
    "Image Template": Image,
    "Document Template": File,
    "Add WhatsApp Template": Plus,
    "Add WhatsApp Image": Plus,
    "Add WhatsApp Document": Plus,
    "Add New User": Plus,
    "Add Source": Plus,
    "Add Course": Plus,
    "Add Branch": Plus,
    "Add Basic Information": Plus,
    "Add City": Plus,
    "Add Status": Plus,
    "Status List": CheckCircle,
    "City List": MapPin,
    "Update Course": Edit,
    "Update Branch": Edit,
    "Update Source": Edit,
    "Update City": Edit,
    "Update Status": Edit,
    "Update Log": FileEdit,
    "Update Admin": Edit,
    "Update User": Edit,
    "Create Proposal": FileText,
    "Proposal List": ClipboardList,
    "Proposal View": FileText,
    "Proposal Greetings": Mail,
    "India Mart": TrendingUp,
    "Create SideMenu": MenuIcon,
    Integration: Settings,
    "Help & Support": HelpCircle,
    "Update Ticket": Edit,
    "Admin List": Shield,
    "Add Admin": Plus,
    "Marketing Dashboard": TrendingUp,
    "Send Campaign": Mail,
    "Create Email templates": Mail,
    "Create / Update Email templates": FileEdit,
    "Email Campaign Analycis": TrendingUp,
    "Create WhatsApp templates": MessageCircle,
    "Create / Update whatsApp templates": FileEdit,
    "Create SMS templates": MessageCircle,
    "Create / Update SMS templates": FileEdit,
    "Demo Enquiries": Inbox,
    "Enquiry Details": FileText,
    "Super Admin Users": Users,
    "Create Super User": Plus,
    "Update Super User": Edit,
    "Add New Enquiry": Plus,
    "CRM Navbar Management": Navigation,
    "Add/Edit Navbar Content": Edit,
    "CRM Legal Policy Management": Scale,
    "Add/Edit Policy Content": Edit,
    "CRM Website Content Management": Settings,
    "CRM Contact Enquiries": Phone,
    "Admission Dashboard": TrendingUp,
    "Admission List": ClipboardList,
    "Admission Form": Plus,
    "View Admission": FileText,
    "WhatsApp Marketing": MessageCircle,
    Notifications: Bell,
  };

  const activeMenu = [
    { link: "/", text: "Dashboard" },
    { link: "/admin-dashboard", text: "Dashboard" },
    { link: "/super-dashboard", text: "Dashboard" },
    { link: "/profile", text: "Profile Settings" },
    { link: "/notifications", text: "Notifications" },
    { link: "/support", text: "Raise Ticket" },
    { link: "/add-lead", text: "Add Lead" },
    { link: "/user-list", text: "Team List" },
    { link: "/user-details/", text: "User Details" },
    { link: "/admin-details/", text: "Admin Details" },
    { link: "/lead-list", text: "Lead List" },
    { link: "/source-list", text: "Source List" },
    { link: "/product-list", text: "Product List" },
    { link: "/branch-list", text: "Branch List" },
    { link: "/template", text: "WhatsApp Template" },
    { link: "/whatsapp-image", text: "Image Template" },
    { link: "/whatsapp-document", text: "Document Template" },
    { link: "/add-message", text: "Add WhatsApp Template" },
    { link: "/add-image", text: "Add WhatsApp Image" },
    { link: "/add-document", text: "Add WhatsApp Document" },
    { link: "/addnewuser", text: "Add New User" },
    { link: "/add-source", text: "Add Source" },
    { link: "/add-course", text: "Add Course" },
    { link: "/add-branch", text: "Add Branch" },
    { link: "/add-basic-information", text: "Add Basic Information" },
    { link: "/add-city", text: "Add City" },
    { link: "/add-status", text: "Add Status" },
    { link: "/status-list", text: "Status List" },
    { link: "/city-list", text: "City List" },
    { link: `/update-course/:id`, text: "Update Course" },
    { link: "/update-branch/:id", text: "Update Branch" },
    { link: "/update-source/:id", text: "Update Source" },
    { link: "/update-city/:id", text: "Update City" },
    { link: "/update-status/:id", text: "Update Status" },
    { link: "/log/:id", text: "Update Log" },
    { link: "/update-admin/:id", text: "Update Admin" },
    { link: "/update-user/:id", text: "Update User" },
    { link: "/proposal", text: "Create Proposal" },
    { link: "/proposal-list", text: "Proposal List" },
    { link: "/proposal-view", text: "Proposal View" },
    { link: "/payment-details", text: "Proposal Payment Details" },
    { link: "/proposal-greeting", text: "Proposal Greetings" },
    { link: "/india-mart", text: "India Mart" },
    { link: "/sidemenu", text: "Create SideMenu" },
    { link: "/integration", text: "Integration" },
    { link: "/super-support", text: "Help & Support" },
    { link: "/update-ticket", text: "Update Ticket" },
    { link: "/admin-list", text: "Admin List" },
    { link: "/addnewadmin", text: "Add Admin" },
    { link: "/marketing-dashboard", text: "Marketing Dashboard" },
    { link: "/send-campaign/:type", text: "Send Campaign" },
    { link: "/create-template-email", text: "Create Email templates" },
    { link: "/email-template-editor", text: "Create / Update Email templates" },
    { link: "/analytics/email", text: "Email Campaign Analycis" },
    { link: "/create-template-whatsapp", text: "Create WhatsApp templates" },
    {
      link: "/whatsApp-template-editor",
      text: "Create / Update whatsApp templates",
    },
    { link: "/create-template-sms", text: "Create SMS templates" },
    { link: "/sms-template-editor", text: "Create / Update SMS templates" },
    { link: "/demo-enquiry-list", text: "Demo Enquiries" },
    { link: "/update-demo-enquiry", text: "Enquiry Details" },
    { link: "/super-admin-user-list", text: "Super Admin Users" },
    { link: "/addnewSuperAdminuser", text: "Create Super User" },
    { link: "/update-super-user/", text: "Update Super User" },
    { link: "/add-new-enquiry", text: "Add New Enquiry" },
    { link: "/navbar-content-list", text: "CRM Navbar Management" },
    { link: "/navbar-content/edit", text: "Add/Edit Navbar Content" },
    { link: "/legal-content-list", text: "CRM Legal Policy Management" },
    { link: "/legal-content/add", text: "Add/Edit Policy Content" },
    {
      link: "/crm-super-admin-dashboard",
      text: "CRM Website Content Management",
    },
    { link: "/contact-enquiry-list", text: "CRM Contact Enquiries" },
    { link: "/lead-field-config", text: "Lead Field Configuration" },
    { link: "/dove-soft", text: "WhatsApp Marketing" },

    // Admission
    { link: "/admission-dashboard", text: "Admission Dashboard" },
    { link: "/admission-list", text: "Admission List" },
    { link: "/admission-form", text: "Admission Form" },
    { link: "/view-admission", text: "View Admission" },
  ];

  const AnimationText = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  const visibleMenu = activeMenu.filter((el) =>
    canShowNavbarAdmissionLink(signinuser, el.link),
  );

  return (
    <Box ml={{ base: 2, md: 4 }}>
      {visibleMenu?.map((el, i) => {
        const isActive =
          location.pathname.split("/")[1] === el.link.split("/")[1];
        const MenuIconComponent = menuIcons[el.text] || LayoutDashboard;

        return isActive ? (
          <motion.div
            key={i}
            initial="hidden"
            animate="visible"
            variants={AnimationText}
          >
            <HStack spacing={2} align="center">
              <Box
                p={1.5}
                bg="gradient-to-br"
                bgGradient="linear(to-br, blue.500, purple.600)"
                borderRadius="lg"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Icon as={MenuIconComponent} w={4} h={4} color="white" />
              </Box>
              <Text
                fontSize={{ base: "sm", md: "lg" }}
                fontWeight="700"
                color="gray.800"
                display={{ base: "none", sm: "block" }}
              >
                {el.text}
              </Text>
            </HStack>
          </motion.div>
        ) : null;
      })}
    </Box>
  );
};

export default Menus;
